/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Sumair Alam",
  title: "Hi all, I'm Sumair",
  subTitle: emoji(
    "A passionate Full Stack Software Developer 🚀 having an experience of building Web applications with JavaScript / Reactjs / Nodejs and some other cool libraries and frameworks."
  ),
  resumeLink:
    "https://drive.google.com/file/d/1qRdbs-11P8Gp_cKIPU_j5reJhBkMqKsP/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/carbonattacker",
  linkedin: "https://www.linkedin.com/in/msumairalam/",
  gmail: "sumair.alam84@gmail.com",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "CRAZY FULL STACK DEVELOPER WHO WANTS TO EXPLORE EVERY TECH STACK",
  skills: [
    emoji(
      "⚡ Develop highly interactive Front end / User Interfaces for your web applications"
    ),
    emoji("⚡ Progressive Web Applications ( PWA ) in normal and SPA Stacks"),
    emoji(
      "⚡ Integration of third party services such as GCP / AWS"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "html-5",
      fontAwesomeClassname: "fab fa-html5"
    },
    {
      skillName: "css3",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "sass",
      fontAwesomeClassname: "fab fa-sass"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "npm",
      fontAwesomeClassname: "fab fa-npm"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "gcp",
      fontAwesomeClassname: "fab fa-google"
    },
    {
      skillName: "python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Indus University",
      logo: require("./assets/images/indusLogo.png"),
      subHeader: "Bachelor of Science in Software Engineering",
      duration: "February 2018 - April 2022",
      desc: "Ranked top 10% in the program. Took courses about Software Engineering, Data Structure & Algorithm, Web Security and Operating Systems",
      descBullets: [
        "Created JARVIS AI System using Supervised Learning for Final Year Project."
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Frontend/Design", //Insert stack or technology you have experience in
      progressPercentage: "90%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Backend",
      progressPercentage: "70%"
    },
    {
      Stack: "Programming",
      progressPercentage: "60%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack Developer",
      company: "Green Developers LLC",
      companylogo: require("./assets/images/greenDevelopersLogo.png"),
      date: "August 2021 – Present",
      // desc: "Green Developers is a dedicated construction firm that brings visions to life with precision and craftsmanship.",
      // descBullets: [
      //   "Implemented dynamic user interfaces using modern front-end frameworks like React.",
      //   "Optimized back-end APIs for seamless data communication, boosting overall application performance.",
      //   "Utilized SQL and NoSQL databases (e.g., PostgreSQL, MongoDB) to design robust data models.",
      //   "Collaborated closely with UI/UX designers to translate wireframes and mockups into functional, pixel-perfect web pages and components.",
      //   "Customized WordPress themes and plugins to meet client-specific design and functionality requirements."
      // ]
    },
    {
      role: "Full Stack Developer",
      company: "MACH3BI",
      companylogo: require("./assets/images/mach3bi.png"),
      date: "July 2020 – August 2021",
      // desc: "MAC3BI provides services by developing customized, scalable, and robust software applications tailored to meet the unique needs of their diverse clientele.",
      // descBullets: [
      //   "Worked with development teams and product managers to ideate software solutions.",
      //   "Designed client-side and server-side architecture.",
      //   "Built the front-end of applications through appealing visual design.",
      //   "Developed and managed well-functioning databases and applications.",
      //   "Tested software to ensure responsiveness and efficiency.",
      //   "Created, Configured and maintained WordPress websites."

      // ]
    },
    {
      role: "Web Developer",
      company: "Smart Tech Services",
      companylogo: require("./assets/images/smarttech.png"),
      date: "Apr 2019 – June 2020"
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Big Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      image: require("./assets/images/casebuddy-logo.png"),
      projectName: "CaseBuddy.pk",
      footerLink: [
        {
          name: "Visit App",
          url: "https://www.casebuddy.pk"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Green-Developers-Logo.png"),
      projectName: "GoDev App",
      // projectDesc: "Green Developers’ SaaS application known as “GoDev”, a software for construction project management which is built on Google Cloud Technologies.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://godevapp.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/Green-Developers-Logo.png"),
      projectName: "Green Developers",
      // projectDesc: "Green Developers’ website built on Next.js, a website for marketing purpose.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://greendevelopers.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/middlechip-logo.png"),
      projectName: "MiddleChip",
      // projectDesc: "Green Developers’ SaaS application known as “GoDev”, a software for construction project management which is built on Google Cloud Technologies.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://hilarious-haupia-79d767.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/profilt-logo.png"),
      projectName: "Profilt",
      // projectDesc: "Green Developers’ SaaS application known as “GoDev”, a software for construction project management which is built on Google Cloud Technologies.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://enchanting-crumble-2892ea.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/developer-portfolio.png"),
      projectName: "Developer Portfolio",
      // projectDesc: "Green Developers’ SaaS application known as “GoDev”, a software for construction project management which is built on Google Cloud Technologies.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://lustrous-alpaca-ada089.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      image: require("./assets/images/inventory-pro.png"),
      projectName: "Inventory Pro",
      // projectDesc: "Green Developers’ SaaS application known as “GoDev”, a software for construction project management which is built on Google Cloud Technologies.",
      footerLink: [
        {
          name: "Visit App",
          url: "https://magnificent-pegasus-053aa1.netlify.app/"
        }
        //  you can add extra buttons here.
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Web Development from Aptech Computer Education",
      subtitle:
        "I've done Web Development Course which helped me to learn JavaScript basics.",
      image: require("./assets/images/aptechIcon.png"),
      imageAlt: "Aptech Computer Education",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        }
      ]
    },
    {
      title: "JavaScript (Basic) Certificate",
      subtitle:
        "Passed JavaScript (Basic) test from HackerRank.",
      image: require("./assets/images/hackerRankIcon.png"),
      imageAlt: "Hacker Rank",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/d3574d6a1855"
        }
      ]
    },
    {
      title: "JavaScript (Intermediate) Certificate",
      subtitle:
        "Passed JavaScript (Intermediate) test from HackerRank.",
      image: require("./assets/images/hackerRankIcon.png"),
      imageAlt: "Hacker Rank",
      footerLink: [
        {
          name: "Certification",
          url: "https://www.hackerrank.com/certificates/5f9c948db9ef"
        }
      ]
    },
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+92-3150267995",
  email_address: "sumair.alam84@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = false; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable
};
